import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add-account",
  "use": "icon-add-account-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add-account\"><defs><style type=\"text/css\"></style></defs><path d=\"M175.893333 769.024l146.602667-171.050667c18.666667 11.669333 38.826667 21.184 60.117333 28.202667L224.490667 810.666667H554.666667v64H224.490667a64 64 0 0 1-48.597334-105.642667l146.602667-171.050667zM746.666667 640v85.333333h85.333333v64h-85.333333v85.333334h-64v-85.333334h-85.333334v-64h85.333334v-85.333333h64zM469.333333 149.333333c117.824 0 213.333333 95.509333 213.333334 213.333334s-95.509333 213.333333-213.333334 213.333333-213.333333-95.509333-213.333333-213.333333S351.509333 149.333333 469.333333 149.333333z m0 64a149.333333 149.333333 0 1 0 0 298.666667 149.333333 149.333333 0 0 0 0-298.666667z\" p-id=\"6708\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/add-account.svg
// module id = 8Y0u
// module chunks = 252